<section class="page-title">
  <!-- add if statement to check if subroutes are present, and if not, color the text -->
  <ol class="breadcrumbs">
    @for (
      breadcrumb of breadcrumbs();
      track breadcrumbTrackBy($index, breadcrumb)
    ) {
      <li class="breadcrumb">
        @if (breadcrumb.url) {
          <a
            [class.active]="isLinkActive(breadcrumb.url)"
            [href]="breadcrumb.url"
            (click)="navigateTo($event, breadcrumb.url)"
            >{{ breadcrumb.label }}
          </a>
        } @else {
          <span>{{ breadcrumb.label }}</span>
        }
      </li>
    }
  </ol>
  <div class="page-title--user">
    <button
      class="page-title--user__initials"
      mat-button
      aria-label="User menu"
      [matMenuTriggerFor]="userMenu"
    >
      <span class="page-title--user__avatar">{{ userInitials$ | async }}</span>
    </button>
    <mat-menu [class]="'top-menu-panel'" class="user-menu" #userMenu="matMenu">
      <button content mat-menu-item (click)="openMyInfo()">
        <div>
          <i class="fa-solid fa-user" aria-hidden="true"></i>
          My Information
        </div>
      </button>
      @if (!isNonSubscribingUser) {
        <button
          content
          mat-menu-item
          aria-haspopup="true"
          [attr.aria-controls]="
            showUserSettings ? 'user-settings-submenu' : null
          "
          [attr.aria-expanded]="showUserSettings"
          (click)="toggleUserSettings($event)"
          style="min-width: 250px"
        >
          <div style="position: relative">
            <i class="fa-sharp fa-gear" aria-hidden="true"></i>
            My Settings
            <i
              class="fa-sharp fa-solid fa-angle-up menu-arrow"
              style="position: absolute; right: -130px"
              [ngClass]="showUserSettings ? 'menu-open' : 'menu-close'"
              aria-hidden="true"
            ></i>
          </div>
        </button>
      }

      @if (showUserSettings) {
        <ol id="user-settings-submenu" class="sub-menu">
          <li>
            <button
              content
              mat-menu-item
              (click)="showUserSettings = false; openNotificationOptions()"
            >
              <div>
                <i class="fa-solid fa-bell" aria-hidden="true"></i>
                Notification Options
              </div>
            </button>
          </li>
          <li>
            <button
              content
              mat-menu-item
              (click)="showUserSettings = false; openSavedTransactions()"
            >
              <div>
                <i
                  class="fa-solid fa-sharp fa-clipboard-check"
                  aria-hidden="true"
                ></i>
                My Saved Transactions
              </div>
            </button>
          </li>
        </ol>
      }

      <button content mat-menu-item (click)="logout()">
        <div>
          <i class="fa-solid fa-sign-out" aria-hidden="true"></i>
          Log out
        </div>
      </button>
    </mat-menu>
  </div>
</section>
